import { FormattedMessage } from "react-intl";
import { FaLongArrowAltUp, FaLongArrowAltDown } from "react-icons/fa";

// export const BASE_URL = process.env.NODE_ENV === "production" ? process.env.REACT_APP_PRODUCTION_URL : process.env.REACT_APP_DEVELOPMENT_URL;
// export const BASE_URL = "http://127.0.0.1:8000/" // Local
// export const BASE_URL = "https://heartcore-dev-api.astutesoftwares00.com/" // Local

// export const BASE_URL = "https://dc23-39-63-60-111.ngrok-free.app/" // Ngrok
// export const BASE_URL = "https://heartcore-dev-api.astutesoftwares00.com/" // Development
// export const BASE_URL = "https://api.heartcorelowcarb.com/" // Production
export const BASE_URL = "https://api.heartcoreglowcarb.com/" // Production

export const IMAGE_URl = (val) => BASE_URL.substr(0, process.env.REACT_APP_PRODUCTION_URL.length - 1) + val;
export const DATE_FORMAT_SERVER = "yyyy-MM-dd";
export const DATE_AND_TIME_FORMAT_DISPLAY = "dd/MM/yyyy hh:mm a";
export const DATE_FORMAT_DISPLAY = "dd/MM/yyyy";
export const ACCESS_TOKEN = "heart_core_crm_access";

export const POPUP_SMALL = "small";
export const POPUP_MEDIUM = "medium";
export const POPUP_LARGE = "large";

export const PRIMARY_COLOR = "#4c0788";


export const LISTING_LIMIT = 100;

export const initialPopupState = {
    component: null,
    visible: false,
    size: "small",
    heading: "",
    contained: false,
    hideDefaultClose: false,
    second_component: false
}


export const MAX_CHARS_BIO = 100;
export const SUPPORTED_IMAGES = ["image/png", "image/jpeg", "image/jpg", "image/webp", "image/gif"]

export const tablesStyles = {
    rows: {
        style: {
            minHeight: '60px', // override the row height
            borderBottom: "0.8px solid #ccc",
        }
    },
    headRow: {
        style: {
            minHeight: '60px',
        },
    },

    headCells: {
        style: {
            color: "#999",
            textTransform: "uppercase",
            fontSize: "12px",
            backgroundColor: "#fff",
            fontWeight: "600"
        }
    },
    cells: {
        style: {
            color: "#000",
            fontWeight: "500",
            minWidth: '120px'
        },
    },
};

export const STATUS_COMPLETED = {
    value: 'completed',
    label: <FormattedMessage id="completed" defaultMessage={"Completed"} />,
    bg: "bg-emerald-100",
    text: "text-emerald-500"
};

export const STATUS_PROCESSING = {
    value: 'processing',
    label: <FormattedMessage id="processing" defaultMessage={"Processing"} />,
    bg: "bg-sky-100",
    text: "text-sky-500"
}
export const STATUS_REFUNDED = {
    value: 'refunded',
    label: <FormattedMessage id="refunded" defaultMessage={"Refunded"} />,
    bg: "bg-cyan-100",
    text: "text-cyan-500"
}
export const STATUS_ARRIVAL_SHIPMENT = {
    value: 'arrival-shipment',
    label: <FormattedMessage id="arrival_shipment" defaultMessage={"Arrival Shipment"} />,
    bg: "bg-amber-100",
    text: "text-amber-500"
}
export const STATUS_CANCELLED = {
    value: 'cancelled',
    label: <FormattedMessage id="cancelled" defaultMessage={"Cancelled"} />,
    bg: "bg-red-100",
    text: "text-red-500"
}
export const STATUS_FAILED = {
    value: "failed",
    label: <FormattedMessage id="failed" defaultMessage={"Failed"} />,
    bg: "bg-red-100",
    text: "text-red-500"

}
export const STATUS_CHECKOUT_DRAFT = {
    value: "checkout-draft",
    label: <FormattedMessage id="checkout_draft" defaultMessage={"Checkout-Draft"} />,
    bg: "bg-amber-100",
    text: "text-amber-500"
}
export const STATUS_ON_HOLD = {
    value: "on-hold",
    label: <FormattedMessage id="on_hold" defaultMessage={"On Hold"} />,
    bg: "bg-teal-100",
    text: "text-teal-500"
};
export const STATUS_ORDINE_SPEDITO = {
    value: "ordine-spedito",
    label: <FormattedMessage id="order_shipped" defaultMessage={"Order Shipped"} />,
    bg: "bg-blue-100",
    text: "text-blue-500"
};
export const STATUS_PENDING = {
    value: "pending",
    label: <FormattedMessage id="pending" defaultMessage={"Pending"} />,
    bg: "bg-amber-100",
    text: "text-amber-500"
};
export const STATUS_INQUEUE = {
    value: "in-queue",
    label: <FormattedMessage id="in_queue" defaultMessage={"In-Queue"} />,
    bg: "bg-blue-100",
    text: "text-blue-500"
};

export const ORDER_STATUS_ARR = [
    STATUS_COMPLETED,
    STATUS_PROCESSING,
    STATUS_REFUNDED,
    STATUS_ARRIVAL_SHIPMENT,
    STATUS_CANCELLED,
    STATUS_FAILED,
    STATUS_CHECKOUT_DRAFT,
    STATUS_ON_HOLD,
    STATUS_ORDINE_SPEDITO,
    STATUS_PENDING,
]

export const FILE_STATUS_ARR = [
    STATUS_COMPLETED,
    STATUS_PROCESSING,
    STATUS_INQUEUE,
    STATUS_PENDING,
]

export const CREATED_VIA_AMAZON = {
    value: "amazon",
    label: <FormattedMessage id="amazon" defaultMessage={"Amazon"} />
}
export const CREATED_VIA_WOOCOMMERCE = {
    value: "checkout",
    label: <FormattedMessage id="woocommerce" defaultMessage={"Checkout"} />
}
export const CREATED_VIA_AMAZON_FBA = {
    value: "amazon-fba",
    label: <FormattedMessage id="amazon_fba" defaultMessage={"Amazon FBA"} />
}

export const BILLING = "billing"
export const SHIPPING = "shipping"

export const FOR_VAT = "yumah"
export const FOR_REDUCED_VAT = "yukatan";

export const IVA_VAT = "IVA";
export const IVA_REDUCED_VAT = "IVA RIDOTTA"

export const FILTER_ALL = { value: "", label: <FormattedMessage id="all" defaultMessage={"All"} /> }


export const ORDER_FROM_ARR = [
    CREATED_VIA_AMAZON,
    CREATED_VIA_WOOCOMMERCE,
    CREATED_VIA_AMAZON_FBA

]

// export const WOO_BASE_URL = "https://heartcoreglowcarb.com/"
// export const WOO_BASE_URL = "https://heartcore.walkin.agency/"
// export const B2B_BASE_URL = "https://b2b.heartcoreglowcarb.com/"
export const WOO_BASE_URL = process.env.NODE_ENV === "production" ? process.env.REACT_APP_PRODUCTION_WOO_URL : process.env.REACT_APP_DEVELOPMENT_WOO_URL;
export const B2B_BASE_URL = process.env.NODE_ENV === "production" ? process.env.REACT_APP_PRODUCTION_B2B_URL : process.env.REACT_APP_DEVELOPMENT_B2B_URL;

export const B2B = "b2b";
export const B2C = "b2c";

export const FILTER_VIA_B2B = {
    value: B2B,
    label: <FormattedMessage id="b2b" defaultMessage={"B2B"} />
}
export const FILTER_VIA_B2C = {
    value: B2C,
    label: <FormattedMessage id="b2c" defaultMessage={"B2C"} />
}

export const ORDER_TYPES_ARR = [
    FILTER_VIA_B2B,
    FILTER_VIA_B2C
]



export const FILTER_ORDERS_BY = [
    {
        value: "date_paid",
        label: <FormattedMessage id="paid_date" defaultMessage={"Paid Date"} />
    },
    {
        value: "date_created",
        label: <FormattedMessage id="order_date" defaultMessage={"Order Date"} />
    },
    {
        value: "date_modified",
        label: <FormattedMessage id="modification_date" defaultMessage={"Modification Date"} />
    },
    {
        value: "date_completed",
        label: <FormattedMessage id="completed_date" defaultMessage={"Completed Date"} />
    },
]

export const EXPORT_FORMATS = [
    {
        value: "xlsx",
        label: <FormattedMessage id="xlsx" defaultMessage={"XLSX"} />
    },
    {
        value: "csv",
        label: <FormattedMessage id="csv" defaultMessage={"CSV"} />
    },
    // {
    //     value: "pdf",
    //     label: <FormattedMessage id="pdf" defaultMessage={"PDF"}/>
    // },
]

export const ORDER_FIELDS_SORT_ARR = [
    {
        value: "csv",
        label: <FormattedMessage id="csv" defaultMessage={"CSV"} />
    },
    {
        value: "xls",
        label: <FormattedMessage id="xls" defaultMessage={"XLS"} />
    },
]

export const ASC_DESC_ARR = [
    {
        value: "asc",
        label: <FormattedMessage id="ascending" defaultMessage={"Ascending"} />
    },
    {
        value: "desc",
        label: <FormattedMessage id="descending" defaultMessage={"Descending"} />
    },
]

export const SORT_BY_ARR = [
    {
        value: "created_on",
        label: <FormattedMessage id="created_date" defaultMessage={"Created Date"} />
    },
    {
        value: "original_name",
        label: <FormattedMessage id="name" defaultMessage={"Name"} />
    },
]


export const SORT_BY_OPTIONS = [
    {
        value: 'original_name-asc',
        label: <FormattedMessage id="name_a_to_z" defaultMessage={"Name (A-Z)"} />
    },
    {
        value: 'original_name-desc',
        label: <FormattedMessage id="name_z_to_a" defaultMessage={"Name (Z-A)"} />
    },
    {
        value: 'created_on-asc',
        label: <FormattedMessage id="date_asc" defaultMessage={"Date (asc)"} />
    },
    {
        value: 'created_on-desc',
        label: <FormattedMessage id="date_desc" defaultMessage={"Date (desc)"} />
    },
];

export const ORDER_FIELDS_ARR_EXPORT = [
    {
        value: "sales_channel",
        label: <FormattedMessage
            id="sales_channel"
            defaultMessage="Sales Channel"
        />,
    },
    {
        value: "woocommerce_order_id",
        label: <FormattedMessage
            id="order_id"
            defaultMessage="Order ID"
        />
    },
    {
        value: "transaction_type",
        label: <FormattedMessage
            id="transaction_type"
            defaultMessage="Transaction Type"
        />
    },
    {
        value: "order_invoice_number",
        label: <FormattedMessage
            id="order_invoice_number"
            defaultMessage="Order Invoice Number"
        />
    },
    {
        value: "geocode_region_long_name",
        label: <FormattedMessage
            id="geocode_region_long_name"
            defaultMessage="Geocode Region Name"
        />
    },
    {
        value: "geocode_province_long_name",
        label: <FormattedMessage
            id="geocode_province_long_name"
            defaultMessage="Geocode Province Name"
        />
    },
    {
        value: "geocode_city_long_name",
        label: <FormattedMessage
            id="geocode_city_long_name"
            defaultMessage="Geocode City Name"
        />
    },
    {
        value: "consent",
        label: <FormattedMessage
            id="consent"
            defaultMessage="Consent"
        />
    },
    {
        value: "total_orders",
        label: <FormattedMessage
            id="total_orders"
            defaultMessage="Total Orders"
        />
    },
    {
        value: "total_value",
        label: <FormattedMessage
            id="total_value"
            defaultMessage="Total Value"
        />
    },
    {
        value: "total_volume",
        label: <FormattedMessage
            id="total_volume"
            defaultMessage="Total Volume"
        />
    },
    {
        value: "date_paid",
        label: <FormattedMessage
            id="date_paid"
            defaultMessage="Date Paid"
        />
    },
    {
        value: "manufacture_country",
        label: <FormattedMessage
            id="manufacture_country"
            defaultMessage="Manufacture Country"
        />
    },
    {
        value: "sku_purchased",
        label: <FormattedMessage
            id="sku_purchased"
            defaultMessage="SKU Purchased"
        />
    },
    {
        value: "purchasing_unit",
        label: <FormattedMessage
            id="purchasing_unit"
            defaultMessage="Purchasing Unit"
        />
    },
    {
        value: "total_quantity",
        label: <FormattedMessage
            id="total_quantity"
            defaultMessage="Total Quanity"
        />
    },
    {
        value: "total_weight",
        label: <FormattedMessage
            id="total_weight"
            defaultMessage="Total Weight"
        />
    },

    {
        value: "order_total_amount",
        label: <FormattedMessage
            id="order_total_amount"
            defaultMessage="Order Total Amount"
        />
    },
    {
        value: "order_total_amount_no_vat_no_ship",
        label: <FormattedMessage
            id="order_total_amount_no_vat_no_ship"
            defaultMessage="Total Order Amount NO VAT No Ship"
        />
    },
    {
        value: "order_total_amount_vat_no_ship",
        label: <FormattedMessage
            id="order_total_amount_vat_no_ship"
            defaultMessage="Total Order Amount with VAT No Ship"
        />
    },
    {
        value: "order_total_amount_vat",
        label: <FormattedMessage
            id="order_total_amount_vat"
            defaultMessage="Total Order VAT"
        />
    },
    {
        value: "order_total_shipping_no_vat",
        label: <FormattedMessage
            id="order_total_shipping_no_vat"
            defaultMessage="Total Order Shipping no VAT"
        />
    },
    {
        value: "order_total_shipping_vat",
        label: <FormattedMessage
            id="order_total_shipping_vat"
            defaultMessage="Total Order Shipping VAT"
        />
    },
    {
        value: "order_total_shipping",
        label: <FormattedMessage
            id="order_total_shipping"
            defaultMessage="Total order shipping "
        />
    },
    {
        value: "total_product_amount_no_vat_no_ship",
        label: <FormattedMessage
            id="total_product_amount_no_vat_no_ship"
            defaultMessage="Total Product Amount No Vat No Shipping"
        />
    },
    {
        value: "total_product_amount_with_vat_no_ship",
        label: <FormattedMessage
            id="total_product_amount_with_vat_no_ship"
            defaultMessage="Total Prod Amount with Vat no Ship"
        />
    },
    {
        value: "total_product_vat_no_ship",
        label: <FormattedMessage
            id="total_product_vat_no_ship"
            defaultMessage="Total Prod Vat No Ship"
        />
    },
    {
        value: "total_product_shipping_no_vat",
        label: <FormattedMessage
            id="total_product_shipping_no_vat"
            defaultMessage="Total Prod Shipping No Vat"
        />
    },
    {
        value: "total_product_shipping_vat",
        label: <FormattedMessage
            id="total_product_shipping_vat"
            defaultMessage="Total Prod Shipping VAT"
        />
    },
    {
        value: "total_product_shipping",
        label: <FormattedMessage
            id="total_product_shipping"
            defaultMessage="Total Product Shipping"
        />
    },
    {
        value: "total_product_vat",
        label: <FormattedMessage
            id="total_product_vat"
            defaultMessage="Total Product VAT"
        />
    },
    {
        value: "currency",
        label: <FormattedMessage
            id="currency"
            defaultMessage="Currency"
        />
    },
    {
        value: "commodity_code",
        label: <FormattedMessage
            id="commodity_code"
            defaultMessage="Commodity Code"
        />
    },
    {
        value: "discount_amount",
        label: <FormattedMessage
            id="discount_amount"
            defaultMessage="DIscount Amount"
        />
    },
    {
        value: "promo_code",
        label: <FormattedMessage
            id="promo_code"
            defaultMessage="Promo Code"
        />
    },
    {
        value: "departure_country",
        label: <FormattedMessage
            id="departure_country"
            defaultMessage="Departure Country"
        />
    },
    {
        value: "arrival_country",
        label: <FormattedMessage
            id="arrival_country"
            defaultMessage="Arrival Country"
        />
    },
    {
        value: "departure_city",
        label: <FormattedMessage
            id="departure_city"
            defaultMessage="Departure City"
        />
    },
    {
        value: "post_code_departure",
        label: <FormattedMessage
            id="post_code_departure"
            defaultMessage="POST Code Departure"
        />
    },
    {
        value: "buyer_name",
        label: <FormattedMessage
            id="buyer_name"
            defaultMessage="Buyer Name"
        />
    },
    {
        value: "buyer_phone",
        label: <FormattedMessage
            id="buyer_phone"
            defaultMessage="Buyer Phone"
        />
    },
    {
        value: "buyer_vat_number",
        label: <FormattedMessage
            id="buyer_vat_number"
            defaultMessage="Buyer VAT Number"
        />
    },
    {
        value: "buyer_vat_country",
        label: <FormattedMessage
            id="buyer_vat_country"
            defaultMessage="Buyer VAT Country"
        />
    },
    {
        value: "shipping_address",
        label: <FormattedMessage
            id="shipping_address"
            defaultMessage="Shipping Address"
        />
    },
    {
        value: "shipping_city",
        label: <FormattedMessage
            id="shipping_city"
            defaultMessage="Shipping CIty "
        />
    },
    {
        value: "country_of_products",
        label: <FormattedMessage
            id="country_of_products"
            defaultMessage="Country Of Products"
        />
    },
    {
        value: "products_destination_code",
        label: <FormattedMessage
            id="products_destination_code"
            defaultMessage="Products Destination Code"
        />
    },
    {
        value: "mode_of_transportation",
        label: <FormattedMessage
            id="mode_of_transportation"
            defaultMessage="Mode of Transportation"
        />
    },
    {
        value: "delivery_conditions",
        label: <FormattedMessage
            id="delivery_conditions"
            defaultMessage="Delivery Conditions"
        />
    },
    {
        value: "seller_vat_in_departure_country",
        label: <FormattedMessage
            id="seller_vat_in_departure_country"
            defaultMessage="Seller VAT In Departure Country"
        />
    },
    {
        value: "seller_vat_in_arrival_country",
        label: <FormattedMessage
            id="seller_vat_in_arrival_country"
            defaultMessage="Seller VAT in Arrival COuntry"
        />
    },
    {
        value: "order_total_discount",
        label: <FormattedMessage
            id="order_total_discount"
            defaultMessage="Sconto Ordine Totale"
        />
    },
    {
        value: "field_1",
        label: <FormattedMessage
            id="field_1"
            defaultMessage="Field 1"
        />
    },
    {
        value: "field_2",
        label: <FormattedMessage
            id="field_2"
            defaultMessage="Field 2"
        />
    },
    {
        value: "field_3",
        label: <FormattedMessage
            id="field_3"
            defaultMessage="Field 3"
        />
    },
    {
        value: "field_4",
        label: <FormattedMessage
            id="field_4"
            defaultMessage="Field 4"
        />
    }

]

export const REVALUE_FIELDS_FOR_EXPORT = [
    {
        label: <FormattedMessage id="seller_vat_in_arrival_country" defaultMessage={"Seller VAT in Arrival Country"} />,
        field: "seller_vat_in_arrival_country",
        value: "IT00294449996",
        placeholder: "IT00294449996"
    },
    {
        label: <FormattedMessage id="seller_vat_in_departure_country" defaultMessage={"Seller VAT in Departure Country"} />,
        field: "seller_vat_in_departure_country",
        value: "IT00294449996",
        placeholder: "IT00294449996",
    },
    {
        label: <FormattedMessage id="delivery_conditions" defaultMessage={"Delivery Conditions"} />,
        field: "delivery_conditions",
        value: "DAP",
        placeholder: "DAP",
    },
    {
        label: <FormattedMessage id="mode_of_transportation" defaultMessage={"Mode of Transportation"} />,
        field: "mode_of_transportation",
        value: "Consignement by post",
        placeholder: "Consignement by post",
    },
    {
        label: <FormattedMessage id="country_of_products" defaultMessage={"Country of Products"} />,
        field: "country_of_products",
        value: "IT",
        placeholder: "IT",
    },
    {
        label: <FormattedMessage id="post_code_departure" defaultMessage={"Post Code Departure"} />,
        field: "post_code_departure",
        value: "20017",
        placeholder: "20017",
    },
    {
        label: <FormattedMessage id="departure_city" defaultMessage={"Departure City"} />,
        field: "departure_city",
        value: "RHO",
        placeholder: "RHO",
    },
    {
        label: <FormattedMessage id="departure_country" defaultMessage={"Departure Country"} />,
        field: "departure_country",
        value: "IT",
        placeholder: "IT",
    },
    {
        label: <FormattedMessage id="field_1" defaultMessage={"Field 1"} />,
        field: "field_1",
        value: "",
        placeholder: "",
    },
    {
        label: <FormattedMessage id="field_2" defaultMessage={"Field 2"} />,
        field: "field_2",
        value: "",
        placeholder: "",
    },
    {
        label: <FormattedMessage id="field_3" defaultMessage={"Field 1"} />,
        field: "field_3",
        value: "",
        placeholder: "",
    },
    {
        label: <FormattedMessage id="field_4" defaultMessage={"Field 2"} />,
        field: "field_4",
        value: "",
        placeholder: "",
    },
]

export const SUPER_ADMIN = "super-admin"
export const NORMAL_USER = "user"
export const LOCAL_ADMIN = "local-admin"
export const OPERATOR = "user"
export const REPO_USER = "repo-user"


export const USER_TYPE_ARRAY = [
    // {
    //     value: SUPER_ADMIN,
    //     label: <FormattedMessage id="admin" defaultMessage={"Admin"} />
    // },
    {
        value: LOCAL_ADMIN,
        label: <FormattedMessage id="local_admin" defaultMessage={"Local Admin"} />
    },
    {
        value: NORMAL_USER,
        label: <FormattedMessage id="operator" defaultMessage={"Operator"} />
    },
    {
        value: REPO_USER,
        label: <FormattedMessage id="repo_user" defaultMessage={"Repo User"} />
    },
]

export const USER_STATUS_ARR = [
    {
        value: "active",
        label: <FormattedMessage id="active_status" defaultMessage={"Active"} />
    },
    {
        value: "disable",
        label: <FormattedMessage id="disabled_status" defaultMessage={"Disabled"} />
    },
    {
        value: "pending",
        label: <FormattedMessage id="pending_status" defaultMessage={"Pending"} />
    },
]



export const FILE = "file"
export const IMAGE_FILE = "image"
export const VIDEO_FILE = "video"
export const PSD_FILE = "psd"
export const PDF_FILE = "pdf"


export const FILE_OPTIONS = [
    {
        label: "All types",
        value: "",
        icon: ""
    },
    {
        label: "Pdf",
        value: PDF_FILE,
        icon: "/images/repo/icons/pdf.svg",
    },
    {
        label: "Images",
        value: IMAGE_FILE,
        icon: "/images/repo/icons/photo.svg"
    },
    {
        label: "videos",
        value: VIDEO_FILE,
        icon: "/images/repo/icons/video.svg"
    },
    {
        label: "Psd",
        value: PSD_FILE,
        icon: "/images/repo/icons/psd.svg"
    },

]



export const CHUNK_SIZE = 10 * 1024 * 1024; // 10MB chunk size

export const ZIP_FILE_PREVIEW_SIZE = 200 * 1024 * 1024; // 20MB file size


export const REPO_HOME_PAGE_URL = "/storage"
export const REPO_FILE_DETAIL_PAGE_URL = "/file-detail"
export const REPO_LISTING_PAGE_URL = REPO_HOME_PAGE_URL + "/my-files"


export const THUBNAIL_FILE_SIZE_LIMIT = 5000000 //5MB


export const ACCEPTED_FILE_THUMBNAILS_TYPES = ['image/jpeg', 'image/jpg', , 'image/png', 'image/webp'];

export const STATUS_CLIENT_SUBSCRIBER = {
    value: "subscriber-client",
    label: <FormattedMessage id="client_subscriber" defaultMessage={"Client + Subscriber"} />,
    bg: "bg-emerald-100",
    text: "text-emerald-500"
}



export const VIEWER_ROLE = {
    value: "viewer",
    label: <FormattedMessage id="viewer" defaultMessage={"Viewer"} />
}

export const EDITOR_ROLE = {
    value: "editor",
    label: <FormattedMessage id="editor" defaultMessage={"Editor"} />
}

export const FILE_ACCESS_ROLE = [
    VIEWER_ROLE,
    EDITOR_ROLE,
]




export const STATUS_CLIENT_NOT_SUBSCRIBER = {
    value: "not-subscriber-client",
    label: <FormattedMessage id="client_not_subscriber" defaultMessage={"Client + Not Subscriber"} />,
    bg: "bg-blue-100",
    text: "text-blue-500"
}

export const STATUS_NOT_CLIENT_SUBSCRIBER = {
    value: "not-client-subscriber",
    label: <FormattedMessage id="not_client_subscriber" defaultMessage={"Not Client + Subscriber"} />,
    bg: "bg-yellow-100",
    text: "text-yellow-500"
}

export const STATUS_NOT_CLIENT_NOT_SUBSCRIBER = {
    value: "not-client-not-subscriber",
    label: <FormattedMessage id="not_client_not_subscriber" defaultMessage={"Not Client + Not Subscriber"} />,
    bg: "bg-red-100",
    text: "text-red-500"
}

export const SUBSCRIBER_STATUS_ARR = [
    STATUS_CLIENT_SUBSCRIBER,
    STATUS_NOT_CLIENT_SUBSCRIBER,
    STATUS_CLIENT_NOT_SUBSCRIBER,
    STATUS_NOT_CLIENT_NOT_SUBSCRIBER
]

export const DATE_DAILY = {
    value: "daily",
    label: <FormattedMessage id="daily" defaultMessage={"Daily"} />,
}
export const DATE_WEEKLY = {
    value: "weekly",
    label: <FormattedMessage id="weekly" defaultMessage={"Weekly"} />,
}
export const DATE_MONTHLY = {
    value: "monthly",
    label: <FormattedMessage id="monthly" defaultMessage={"Monthly"}/>,
}
export const DATE_YEARLY = {
    value: "yearly",
    label: <FormattedMessage id="yearly" defaultMessage={"Yearly"} />,
}

export const DATE_FILTER_TYPES = [
    // DATE_DAILY,
    DATE_WEEKLY,
    DATE_MONTHLY,
    DATE_YEARLY
]

export const TAG_TYPE_YUMAH = {
    value: "yumah",
    label: <FormattedMessage id="yumah" defaultMessage={"Yumah"} />
}
export const TAG_TYPE_YUKATAN = {
    value: "yukatan",
    label: <FormattedMessage id="yukatan" defaultMessage={"Yukatan"} />
}
export const TAG_TYPE_TOTAL = {
    value: "total",
    label: <FormattedMessage id="total" defaultMessage={"Total"} />
}
export const TAG_TYPE_ARR = [
    TAG_TYPE_YUMAH,
    TAG_TYPE_YUKATAN,
    TAG_TYPE_TOTAL
]